import React from "react";
import styled from "styled-components";

const expertiseAreas = [
  { name: "PLM Products", icon: "fa-solid fa-cogs" },
  { name: "Manufacturing & MES", icon: "fa-solid fa-industry" },
  { name: "Data Migration & Upgrades", icon: "fa-solid fa-database" },
  { name: "CAD & ERP Integration", icon: "fa-solid fa-project-diagram" },
  { name: "App Development", icon: "fa-solid fa-mobile-alt" },
  { name: "Cloud Transitions", icon: "fa-solid fa-cloud" },
  { name: "ODC Setup", icon: "fa-solid fa-building" },
  { name: "Mendix App Development", icon: "fa-solid fa-code" },
];

const ExpertiseAreaSection = styled.section`
  padding: 50px 20px;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }

  @media (max-width: 576px) {
    padding: 30px 10px;
  }
`;

const Container = styled.div`
  .container {
    font-family: "Poppins", system-ui;
  }
`;

const ExpertiseTitle = styled.h4`
  font-size: 3em;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #06334b;

  text-align: left;

  span {
    color: #07b6f2;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 576px) {
    font-size: 2em;
  }
`;

const Paragraph = styled.p`
  font-size: 1.1em;
  color: #777777;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
  margin-top: 1em;
  margin-bottom: 2em;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 576px) {
    font-size: 1em;
    line-height: 1.71;
    text-align: justify;
  }
`;

const Card = styled.div`
  transition: transform 0.3s, box-shadow 0.3s;
  border: none;
  border-radius: 15px;
  background: linear-gradient(145deg, #ffffff, #f0f0f0);
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }
`;

const CardBody = styled.div`
  text-align: center;
`;

const CustomIcon = styled.i`
  font-size: 3rem;
  background-color: #07b6f2;
  border-radius: 50%;
  padding: 20px;
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    padding: 15px;
    height: 80px;
    width: 80px;
  }

  @media (max-width: 576px) {
    font-size: 2rem;
    padding: 10px;
    height: 60px;
    width: 60px;
  }
`;

const ExpertiseH6 = styled.h6`
  margin-top: 1rem;
  text-align: center;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #06334b;
  font-size: 1.1em;
  line-height: 1.71;
  

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 10px;
    font-family: "Space Grotesk", sans-serif;
  }
`;

const ExpertiseArea = () => {
  return (
    <ExpertiseAreaSection className="expertisearea">
      <Container className="container" id="icon-grid">
        <ExpertiseTitle className="text-left">
          Our Expertise <span>Areas</span>
        </ExpertiseTitle>
        <Paragraph className="text-left paragraph">
          Our team of experts has a wide range of expertise in various fields.
          We specialize in the following areas:
        </Paragraph>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 justify-content-center">
          {expertiseAreas.map((area, index) => (
            <div className="col" key={index}>
              <Card className="card custom-expertise-card h-100 border-0 shadow">
                <CardBody className="card-body d-flex flex-column align-items-center justify-content-center">
                  <CustomIcon
                    className={`${area.icon} custom-icon mb-3`}
                  ></CustomIcon>
                  <ExpertiseH6 className="mb-0 text-body-emphasis text-center">
                    {area.name}
                  </ExpertiseH6>
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </Container>
    </ExpertiseAreaSection>
  );
};

export default ExpertiseArea;
